var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMojito(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8F2F8",
    d: "m333.5 154.5 40 52v240a40 40 0 0 1-40 40h-230a40 40 0 0 1-40-40v-240l40-52z",
    opacity: 1,
    "data-original": "#e8f2f8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACD1E4",
    d: "m133.5 154.502-40 52h-30l40-52z",
    opacity: 1,
    "data-original": "#acd1e4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8F2F8",
    d: "M363.5 236.5v40h35a10 10 0 0 1 10 10v80a10 10 0 0 1-10 10h-35v40h45a40 40 0 0 0 40-40v-100a40 40 0 0 0-40-40z",
    opacity: 1,
    "data-original": "#e8f2f8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACD1E4",
    d: "M363.5 236.5h29v40h-29zM363.5 376.5h29v40h-29z",
    opacity: 1,
    "data-original": "#acd1e4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 35,
    x: 78.5,
    y: 136.5,
    fill: "#E8F2F8",
    rx: 15,
    opacity: 1,
    "data-original": "#e8f2f8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 35,
    x: 78.5,
    y: 101.5,
    fill: "#E8F2F8",
    rx: 15,
    opacity: 1,
    "data-original": "#e8f2f8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACD1E4",
    d: "M358.29 114a15.007 15.007 0 0 1-14.79 12.5h-220a15 15 0 0 1-15-15v-10h-15a15 15 0 0 0-15 15v5a14.988 14.988 0 0 0 14.119 14.956c.282.026.573.044.881.044h250a15 15 0 0 0 15-15v-5a14.712 14.712 0 0 0-.21-2.5zM358.29 149a15.007 15.007 0 0 1-14.79 12.5h-220a15 15 0 0 1-15-15v-10h-15a15 15 0 0 0-15 15v5a14.988 14.988 0 0 0 14.119 14.956c.282.026.573.044.881.044h250a15 15 0 0 0 15-15v-5a14.712 14.712 0 0 0-.21-2.5z",
    opacity: 1,
    "data-original": "#acd1e4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F15D40",
    d: "M306.182 44.052 244.654 213.08h-37.24l65.879-181a10 10 0 0 1 12.819-5.975l3.752 1.366 10.34 3.761a10 10 0 0 1 5.978 12.82z",
    opacity: 1,
    "data-original": "#f15d40"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC4F3C",
    d: "M289.864 27.473 222.313 213.08h-14.9l65.879-181a10 10 0 0 1 12.819-5.975z",
    opacity: 1,
    "data-original": "#dc4f3c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFC8AC",
    d: "m251.214 133.683-12.74 35h-14.9l12.74-35z",
    opacity: 1,
    "data-original": "#dfc8ac"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC6140",
    d: "m285.27 101.497-12.74 35h-37.25l12.74-35z",
    opacity: 1,
    "data-original": "#cc6140"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7523C",
    d: "m262.92 101.497-12.74 35h-14.9l12.74-35z",
    opacity: 1,
    "data-original": "#b7523c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7523C",
    d: "m276.16 126.497-3.64 10h-37.24l3.64-10z",
    opacity: 1,
    "data-original": "#b7523c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC6140",
    d: "m272.53 136.497-12.74 35h-37.24l12.73-35z",
    opacity: 1,
    "data-original": "#cc6140"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7523C",
    d: "m250.18 136.497-12.74 35h-14.89l12.73-35z",
    opacity: 1,
    "data-original": "#b7523c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7523C",
    d: "m263.43 161.497-3.64 10h-37.24l3.64-10z",
    opacity: 1,
    "data-original": "#b7523c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6BD4E0",
    d: "M373.5 206.5v240a40 40 0 0 1-40 40h-230a40 40 0 0 1-40-40v-240z",
    opacity: 1,
    "data-original": "#6bd4e0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#56CDD3",
    d: "M133.5 486.5h-30a40 40 0 0 1-40-40v-240h30v240a40 40 0 0 0 40 40z",
    opacity: 1,
    "data-original": "#56cdd3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    x: 268.217,
    y: 238.768,
    fill: "#F3EADE",
    rx: 15,
    transform: "rotate(-70 303.087 273.685)",
    opacity: 1,
    "data-original": "#f3eade"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8BC932",
    d: "M200.015 288.7c48.652 13.406 62.489 51.185 33.963 92.731l-.138.2-.236-.066c-48.557-13.488-62.242-51.323-33.589-92.865z",
    opacity: 1,
    "data-original": "#8bc932"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80B524",
    d: "M230.789 380.751a7.5 7.5 0 0 1-7.048-4.937l-19.947-54.8a7.5 7.5 0 0 1 14.1-5.13l19.946 54.8a7.5 7.5 0 0 1-7.047 10.067z",
    opacity: 1,
    "data-original": "#80b524"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8BC932",
    d: "M157.382 233.973c-55.368 5.238-77.615 43.593-54.606 94.142l.111.245.268-.026c55.282-5.348 77.374-43.792 54.227-94.361z",
    opacity: 1,
    "data-original": "#8bc932"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80B524",
    d: "M107.8 327.347a7.5 7.5 0 0 1-6.488-11.251l35.07-60.744a7.5 7.5 0 0 1 12.991 7.5L114.3 323.6a7.5 7.5 0 0 1-6.5 3.747z",
    opacity: 1,
    "data-original": "#80b524"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.5,
    cy: 397.999,
    r: 65,
    fill: "#FFC443",
    opacity: 1,
    "data-original": "#ffc443"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.5,
    cy: 397.999,
    r: 40,
    fill: "#F9D36B",
    opacity: 1,
    "data-original": "#f9d36b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC443",
    d: "M317.25 411.711 293.5 398l23.75-13.712a7.5 7.5 0 1 0-7.5-12.99L286 385.009v-27.425a7.5 7.5 0 0 0-15 0v27.425L247.25 371.3a7.5 7.5 0 0 0-7.5 12.99L263.5 398l-23.75 13.712a7.5 7.5 0 1 0 7.5 12.99L271 410.989v27.424a7.5 7.5 0 0 0 15 0v-27.424l23.75 13.711a7.5 7.5 0 1 0 7.5-12.99z",
    opacity: 1,
    "data-original": "#ffc443"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1DDC8",
    d: "m329.69 303.369-.42 1.16a15.01 15.01 0 0 1-19.23 8.97l-37.59-13.69a14.99 14.99 0 0 1-8.96-19.22L277.17 243a14.988 14.988 0 0 1 19.22-8.96l.35.13-13.25 36.42a14.99 14.99 0 0 0 8.96 19.22z",
    opacity: 1,
    "data-original": "#f1ddc8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    x: 104.5,
    y: 383.332,
    fill: "#F3EADE",
    rx: 15,
    transform: "rotate(-79.98 139.557 418.284)",
    opacity: 1,
    "data-original": "#f3eade"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1DDC8",
    d: "M170.109 445.743a14.99 14.99 0 0 1-16.99 10.53l-39.39-6.94a15 15 0 0 1-12.17-17.38l6.94-39.39a15 15 0 0 1 17.38-12.17l3.01.531a14.5 14.5 0 0 0-.39 1.639l-6.94 39.39a15 15 0 0 0 12.17 17.38z",
    opacity: 1,
    "data-original": "#f1ddc8"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#525651"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.5 229H381v-22.5a7.457 7.457 0 0 0-1.517-4.509c-.014-.021-.022-.043-.038-.064l-21.613-28.1A22.463 22.463 0 0 0 366 156.5v-5a22.411 22.411 0 0 0-5.747-15 22.411 22.411 0 0 0 5.747-15v-5A22.525 22.525 0 0 0 343.5 94h-47.518l17.247-47.382a17.5 17.5 0 0 0-10.462-22.432l-14.088-5.126a17.5 17.5 0 0 0-22.434 10.457L242.774 94H191.06a7.5 7.5 0 0 0 0 15h46.255l-32.758 90H78.732l15.384-20H197.55a7.5 7.5 0 0 0 0-15H93.5a7.509 7.509 0 0 1-7.5-7.5v-5a7.509 7.509 0 0 1 7.5-7.5h14.3a7.5 7.5 0 0 0 0-15H93.5a7.508 7.508 0 0 1-7.5-7.5v-5a7.508 7.508 0 0 1 7.5-7.5h72.978a7.5 7.5 0 0 0 0-15H93.5A22.525 22.525 0 0 0 71 116.5v5a22.411 22.411 0 0 0 5.747 15 22.411 22.411 0 0 0-5.747 15v5a22.463 22.463 0 0 0 8.168 17.331l-21.613 28.1c-.016.021-.024.043-.038.064A7.457 7.457 0 0 0 56 206.5v136.23a7.5 7.5 0 0 0 15 0V214h154.451a7.5 7.5 0 1 0 0-15h-4.931l59.82-164.352a2.5 2.5 0 0 1 3.205-1.494l14.095 5.129a2.5 2.5 0 0 1 1.5 3.2l-52.179 143.332a7.5 7.5 0 0 0 14.095 5.131L290.521 109H343.5a7.508 7.508 0 0 1 7.5 7.5v5a7.508 7.508 0 0 1-7.5 7.5h-43.969a7.5 7.5 0 0 0 0 15H343.5a7.508 7.508 0 0 1 7.5 7.5v5a7.508 7.508 0 0 1-7.5 7.5h-56.71a7.5 7.5 0 0 0 0 15h56.094l15.384 20H272.53a7.5 7.5 0 0 0 0 15H366v30.012a7.5 7.5 0 0 0 15 0V244h27.5a32.538 32.538 0 0 1 32.5 32.5v100a32.537 32.537 0 0 1-32.5 32.5H381V284h17.5a2.5 2.5 0 0 1 2.5 2.5v80a2.5 2.5 0 0 1-2.5 2.5h-4a7.5 7.5 0 0 0 0 15h4a17.52 17.52 0 0 0 17.5-17.5v-80a17.521 17.521 0 0 0-17.5-17.5H381v-.545a7.5 7.5 0 1 0-15 0V446.5a32.538 32.538 0 0 1-32.5 32.5h-230A32.538 32.538 0 0 1 71 446.5v-78a7.5 7.5 0 0 0-15 0v78a47.555 47.555 0 0 0 47.5 47.5h230a47.555 47.555 0 0 0 47.5-47.5V424h27.5a47.554 47.554 0 0 0 47.5-47.5v-100a47.555 47.555 0 0 0-47.5-47.5z",
    fill: "#525651",
    opacity: 1,
    "data-original": "#525651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.887 306.864 37.587 13.681a22.5 22.5 0 0 0 28.839-13.445l13.681-37.587a22.526 22.526 0 0 0-13.448-28.839l-37.587-13.684a22.5 22.5 0 0 0-28.839 13.448l-13.681 37.588a22.5 22.5 0 0 0 13.448 28.838zm.648-23.708 13.681-37.588a7.484 7.484 0 0 1 9.613-4.482l37.587 13.68a7.509 7.509 0 0 1 4.482 9.614l-13.68 37.587a7.511 7.511 0 0 1-9.613 4.483l-37.588-13.682a7.507 7.507 0 0 1-4.482-9.612zM156.675 226.506c-29.282 2.771-51.48 14.785-62.5 33.829-11.165 19.292-10.551 43.8 1.774 70.882l.112.245a7.5 7.5 0 0 0 6.825 4.4c.244 0 .491-.012.738-.036l.255-.025c29.619-2.866 51.154-14.589 62.279-33.9 10.982-19.068 10.287-44.3-1.955-71.043a7.506 7.506 0 0 0-7.528-4.352zm-3.518 67.9c-6.745 11.712-19.01 19.851-35.847 23.972l32.059-55.528a7.5 7.5 0 0 0-12.991-7.5l-32.059 55.529c-4.849-16.639-3.935-31.333 2.837-43.032 8-13.832 23.693-22.686 45.55-25.777 8.251 20.476 8.427 38.489.451 52.338zM162.269 379.191a7.5 7.5 0 0 0-2.605 14.773l4.308.759a7.508 7.508 0 0 1 6.083 8.688l-6.946 39.389a7.507 7.507 0 0 1-8.688 6.084l-39.392-6.946a7.509 7.509 0 0 1-6.084-8.689l6.946-39.392a7.506 7.506 0 0 1 8.688-6.084l9.837 1.735a7.5 7.5 0 1 0 2.6-14.772l-9.837-1.735a22.529 22.529 0 0 0-26.065 18.251l-6.947 39.393a22.527 22.527 0 0 0 18.252 26.065l39.392 6.946a22.486 22.486 0 0 0 26.065-18.251l6.947-39.393a22.526 22.526 0 0 0-18.251-26.065zM202.007 281.47a7.5 7.5 0 0 0-8.166 2.972c-14.229 20.629-19.212 41.155-14.412 59.358 3.858 14.63 13.854 26.811 29.022 35.525a72.7 72.7 0 1 0 20.195-33.89l-10.756-29.554a7.5 7.5 0 0 0-14.1 5.13l13.758 37.8q-1.969 3.054-3.635 6.307c-10.479-6.549-17.345-15.135-19.984-25.143-3.322-12.6-.111-27.193 9.287-42.467 16.018 5.334 27.515 13.777 33.419 24.6a7.5 7.5 0 0 0 13.169-7.18c-8.514-15.619-25.043-27.189-47.797-33.458zM278.5 340.5A57.5 57.5 0 1 1 221 398a57.565 57.565 0 0 1 57.5-57.5z",
    fill: "#525651",
    opacity: 1,
    "data-original": "#525651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.5 445.5A47.5 47.5 0 1 0 231 398a47.555 47.555 0 0 0 47.5 47.5zM311 398a32.38 32.38 0 0 1-1.367 9.314L293.5 398l16.133-9.315A32.392 32.392 0 0 1 311 398zm-25-31.617a32.5 32.5 0 0 1 16.115 9.323L286 385.009zm0 44.607 16.115 9.3A32.511 32.511 0 0 1 286 429.616zm-15 18.627a32.511 32.511 0 0 1-16.115-9.323l16.115-9.3zm0-63.234v18.627l-16.115-9.3A32.5 32.5 0 0 1 271 366.382zm-23.633 22.3L263.5 398l-16.133 9.314a32.417 32.417 0 0 1 0-18.629zM122.635 136.5a7.5 7.5 0 0 0 7.5 7.5h78.145a7.5 7.5 0 0 0 0-15h-78.145a7.5 7.5 0 0 0-7.5 7.5z",
    fill: "#525651",
    opacity: 1,
    "data-original": "#525651"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.54,
    cy: 206.5,
    r: 7.5,
    fill: "#525651",
    opacity: 1,
    "data-original": "#525651"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMojito);
export default __webpack_public_path__ + "static/media/Mojito.4e457189fd067390c4029243b978de3a.svg";
export { ForwardRef as ReactComponent };